import axios from "axios";
import { environments } from "../environments";
import { getTokens } from "../services/data";

export const apiPlataforma = axios.create({
  baseURL: environments.urlApiPlataforma,
});

apiPlataforma.interceptors.request.use(
  (config) => {
    const tokens = getTokens();
    const headers = (config.headers ??= {} as any);

    const headerOps = (() => {
      const hasSet = typeof headers?.set === "function";
      const hasDelete = typeof headers?.delete === "function";

      switch (true) {
        case hasSet && hasDelete:
          return {
            set: (k: string, v: string) => headers.set(k, v),
            del: (k: string) => headers.delete(k),
          };

        case hasSet && !hasDelete:
          return {
            set: (k: string, v: string) => headers.set(k, v),
            del: (k: string) => delete headers[k],
          };

        default:
          return {
            set: (k: string, v: string) => {
              headers[k] = v;
            },
            del: (k: string) => {
              delete headers[k];
            },
          };
      }
    })();

    const applyTokenHeader = (headerName: string, token?: string) => {
      return token ? headerOps.set(headerName, token) : headerOps.del(headerName);
    };

    applyTokenHeader("X-TN-TOKEN", tokens["x-tn-token"]);
    applyTokenHeader("X-AUTH-TOKEN", tokens["x-auth-token"]);

    return config;
  },
  (error) => Promise.reject(error),
);
